import React from 'react';
import { Route } from 'react-router-dom';
import StaffLayout from '../views/Staff/StaffLayout';
import StaffProfile from '../views/Staff/StaffProfile';

const staffRoutes = (
  <Route path="/staff" element={<StaffLayout />}>
    <Route index element={<StaffProfile />} />
    <Route path="profile" element={<StaffProfile />} />
  </Route>
);

export default staffRoutes;
